module.exports = __webpack_public_path__ + "img/appIcon-menu--Reports--active.b8540be2.svg";